export const swrImmutableConfigs = (isImmutable: boolean) =>
  isImmutable
    ? {
        revalidateIfStale: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false
      }
    : {};
